import '.bn{position:relative;}.ssr-plugin'
import '.ib{width:64px;}.ssr-plugin'
import '.ic{height:64px;}.ssr-plugin'
import '.bp{flex-shrink:0;}.ssr-plugin'
import '.m{position:absolute;}.ssr-plugin'
import '.id{bottom:-4px;}.ssr-plugin'
import '.cz{right:-4px;}.ssr-plugin'
import '.dm{border-radius:50%;}.ssr-plugin'
import '.ie{border:2px solid var(--shades-white);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.if{width:32px;}.ssr-plugin'
import '.ig{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bn ib ic bp"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="m id cz dm ie q if ig"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
